export default "__VITE_ASSET__BnBgWnRu__"